// dependencies.
import { get } from 'lodash'

// detect the base URL.
const REGISTER_TO_PROFESSIONAL = get(process.env, 'REGISTER_TO_PROFESSIONAL')

/**
 * detect the api base URL
 */
export default REGISTER_TO_PROFESSIONAL



// WEBPACK FOOTER //
// ./src/plugins/http/professional-register.js